
import StoreList from './components/StoreList.vue';
import LeafletMap from './components/LeafletMap.vue';
import {defineComponent} from "vue";

export default defineComponent({
  components: {
    LeafletMap,
    StoreList
  }
});
